import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay, Grid } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/grid';

function initHomeSwipers() {
    document.querySelectorAll('.swiper--auto').forEach((swiperEl) => {

        const nextEl = swiperEl.querySelector('.swiper__next');
        const prevEl = swiperEl.querySelector('.swiper__prev');
        const paginationEl = swiperEl.querySelector('.swiper__pagination-inner');
        const progressBar = swiperEl.querySelector('.swiper__progress-bar');

        new Swiper(swiperEl, {
            modules: [Navigation, Pagination, EffectFade, Autoplay],

            loop: true,
            speed: 800,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },

            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },

            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            },

            pagination: {
                el: paginationEl,
                type: 'fraction',
                formatFractionCurrent: (number) => {
                    return number < 10 ? `0${number}` : number;
                },
                formatFractionTotal: (number) => {
                    return number < 10 ? `0${number}` : number;
                },
                renderFraction(currentClass, totalClass) {
                    return `
                        <span class="${currentClass}"></span>
                        <span>-</span>
                        <span class="${totalClass}"></span>
                    `;
                },
            },

            on: {
                autoplayTimeLeft(swiper, time, progress) {
                    if (progressBar) {
                        progressBar.style.transform = `scaleX(${1 - progress})`;
                    }
                },
            },
        });
    });
}

function mobileSwiper() {
    const alternateSwiper = new Swiper('.swiper--alt', {
        modules: [Grid, Navigation],
        breakpoints: {
            0: {
                slidesPerView: 3,
                spaceBetween: 12,
                grid: {
                    rows: 2,
                    fill: 'row', 
                    gap: {
                            vertical: 16,
                            horizontal: 12,
                    },
                },
            },
            992: {
                enabled: false,
            },
        }
    });
}

function initModalSwiper() {
    const swiper = new Swiper('.swiper--modal', {
        modules: [Navigation],
        navigation: {
            nextEl: '.swiper__next',
            prevEl: '.swiper__prev',
        },
    });
    return swiper;
}

// Export globally so product-ajax.js can use it
window.initModalSwiper = initModalSwiper;

(function () {
  // Prevent double initialization
  if (window.videoModalInitialized) return;
  window.videoModalInitialized = true;

  const modal = document.getElementById('videoModal');
  const iframe = document.getElementById('videoModalIframe');
  const openButtons = document.querySelectorAll('.js-open-video-modal');
  const closeButtons = document.querySelectorAll('.js-close-video-modal');

  if (!modal || !iframe || !openButtons.length) return;

  let lastFocusedElement = null;

  /* ==============================
     OPEN MODAL
  ============================== */
  function openModal(videoSrc) {
    lastFocusedElement = document.activeElement;

    // Set iframe src ONLY when opening
    iframe.src = videoSrc;

    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-modal-open');

    // Focus modal for accessibility
    modal.querySelector('.video-modal__close')?.focus();
  }

  /* ==============================
     CLOSE MODAL
  ============================== */
  function closeModal() {
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-modal-open');

    // Stop video completely (critical)
    iframe.src = '';

    // Restore focus
    lastFocusedElement?.focus();
  }

  /* ==============================
     EVENT BINDINGS
  ============================== */

  // Open buttons
  openButtons.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();
      const videoSrc = button.getAttribute('data-video-src');
      if (!videoSrc) return;
      openModal(videoSrc);
    });
  });

  // Close buttons (overlay + close icon)
  closeButtons.forEach(button => {
    button.addEventListener('click', closeModal);
  });

  // ESC key support
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && modal.classList.contains('is-active')) {
      closeModal();
    }
  });

  // Prevent click inside content from closing modal
  modal.querySelector('.video-modal__content')
    ?.addEventListener('click', e => e.stopPropagation());

})();


document.addEventListener('DOMContentLoaded', () => {
    initHomeSwipers(),
    mobileSwiper()
});